import PagePullLoadIcon from '../PagePullLoadIcon'
import { PagePullWrap } from './Style'

interface PagePullLoadProps {
  paused?: boolean
  [key: string]: any
}

export default function PagePullLoad({ paused = false, ...props }: PagePullLoadProps) {
  if (paused) {
    return (
      <PagePullWrap {...props}>
        <PagePullLoadIcon paused={true} pausedAt={1000} />
      </PagePullWrap>
    )
  } else {
    return (
      <PagePullWrap {...props}>
        <PagePullLoadIcon />
      </PagePullWrap>
    )
  }
}
